import { Paper, PaperProps, styled } from "@mui/material";
import React from "react";
import { pxToRem } from "../../../utils/fontSizeUtility";

export const CardListPaper = styled(Paper)<PaperProps>(({ theme }) => ({
  padding: 16,
  boxSizing: "border-box",
  width: "100%",
  boxShadow: "3",
  marginBottom: pxToRem(15),
})) as React.ComponentType<PaperProps>;
